import { generateRandomNumber, generateRandomNumberSeries } from "../../../utils";

export const generatePath = (serie, items, initX, initY) => {
    const deltaOps = [{ dx: 0, dy: -1 }, { dx: 1, dy: 0 }, { dx: 0, dy: 1 }, { dx: -1, dy: 0 }];
    const prevPositions = [{ x: initX, y: initY }];

    items[initX][initY].val = serie[0];
    items[initX][initY].selected = true;
    items[initX][initY].ispath = true;

    for (let idx = 1; idx < serie.length; idx++) {
        const prevDelta = [];
        for (let p = 0; p < 20; p++) {
            //   console.log('generatePath prevPositions: iter:', idx, prevPositions);

            let delta = deltaOps[Math.floor(Math.random() * deltaOps.length)];
            while (prevDelta.find(aD => aD.dx === delta.dx && aD.dy === delta.dy)) {
                delta = deltaOps[Math.floor(Math.random() * deltaOps.length)];
            }

            if (!prevPositions[idx - 1]) {
                serie = serie.slice(0, idx);
                return; // not previous elem generate, break!
            }

            const newX = prevPositions[idx - 1].x + delta.dx;
            const newY = prevPositions[idx - 1].y + delta.dy;

            const aPos = prevPositions.find(aP => aP.x === newX && aP.y === newY);
            //   console.log('generatePath newPos: iter:', idx, aPos,'::', newX, newY, prevPositions);

            if (!aPos && !(newX < 0 || newY < 0 || newX >= items.length || newY >= items[0].length)) {
                prevPositions.push({ x: newX, y: newY });
                items[newX][newY].val = serie[idx];
                items[newX][newY].selected = false;
                items[newX][newY].ispath = true;

                break;
            }
        }
    }

    // console.log('generatePath prevPositions:', prevPositions);
};

export const generateForwardPath = (serie, items, initX, initY, endX, endY, min, max) => {
    const deltaOps = [{ dx: 1, dy: 0 }, { dx: 0, dy: 1 }, { dx: -1, dy: 0 }];
    const prevPositions = [{ x: initX, y: initY }];

    items[initX][initY].val = serie[0];
    items[initX][initY].selected = true;
    items[initX][initY].ispath = true;

    let curPos = { x: initX, y: initY };
    let idx = 1;

    while (curPos.x != endX || curPos.y != endY) {

        const prevDelta = [];
        if (!prevPositions[idx - 1]) break;

        for (let p = 0; p < 20; p++) {
            // console.log('generateForwardPath prevPositions: iter:', idx, prevPositions);

            let delta = deltaOps[Math.floor(Math.random() * deltaOps.length)];
            while (prevDelta.find(aD => aD.dx === delta.dx && aD.dy === delta.dy)) {
                delta = deltaOps[Math.floor(Math.random() * deltaOps.length)];
            }

            const newX = prevPositions[idx - 1].x + delta.dx;
            const newY = prevPositions[idx - 1].y + delta.dy;

            const aPos = prevPositions.find(aP => aP.x === newX && aP.y === newY);
            //   console.log('generateForwardPath newPos: iter:', idx, aPos,'::', newX, newY, prevPositions);

            if (!aPos && !(newX < 0 || newY < 0 || newX >= items.length || newY >= items[0].length)) {
                const newVal = generateRandomNumber(min, max);

                serie.push(newVal);

                prevPositions.push({ x: newX, y: newY });
                items[newX][newY].val = newVal;
                items[newX][newY].selected = false;
                items[newX][newY].ispath = true;

                curPos = { x: newX, y: newY };

                break;
            }
        }

        idx++;
        // console.log('generateForwardPath curPos: ', curPos, '::', endX, endY);

    }

    return curPos;

    // console.log('generatePath prevPositions:', prevPositions);
};

export const generatePathItems = (num_items, init, finish, value, cols, rows, initpos, endpos) => {
    // console.log('generatePathItems:', num_items, init, finish, value, cols, rows, initpos, endpos);


    const MAX_ROWS = 5;
    const MAX_COLS = 4;

    const lSerie = [0];
    for (let idx = 1; idx < num_items; idx++) {
        lSerie.push(0);
    }

    // console.log('lSerie init:', lSerie);

    const COLS = cols ? cols : MAX_COLS;
    const ROWS = rows ? rows : MAX_ROWS;
    const initX = initpos ? initpos.x : 0;
    const initY = initpos ? initpos.y : 0;
    const endX = endpos ? endpos.x : ROWS - 1;
    const endY = endpos ? endpos.y : COLS - 1;

    // console.log('ForwardGrid COLS ROWS initX initY:', COLS, ROWS, initX, initY);

    let lItems = [];
    for (let ydx = 0; ydx < ROWS; ydx++) {
        const aRow = [];
        const numbers = generateRandomNumberSeries(COLS, init, finish, value ? [value] : null);
        for (let xdx = 0; xdx < COLS; xdx++) {
            // const isSelected = xdx == initX && ydx == initY;
            aRow.push({ val: numbers[xdx], x: xdx, y: ydx });
        }

        lItems.push(aRow);
    }

    // console.log('ForwardGrid lSerie:', lSerie, '::lItems:', lItems);

    const llastPos = generateForwardPath(lSerie, lItems, initX, initY, endX, endY, init, finish);
    const lSolution = lSerie.reduce((acc, val) => acc + val, 0);

    return [lItems, lSolution, llastPos];
};
